import moment from "moment";
import { Link, useLocation, useParams, useHistory } from "react-router-dom";
import { getCustomerNotification, getCustomerNotificationDetail } from "../../../../../actions/notification";
import { useSelector, useDispatch } from "react-redux";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import SkeletonLoading from "./SkeletonLoading";
import Moment from "react-moment";
import { ArrowRightIcon, BackAltIcon } from "../../../../../components/icons";

const NotificationDetail = ({ match }) => {
  const customerNotificationDetail = useSelector((state) => state.notification);
  const { loading, notification } = customerNotificationDetail;
  const dispatch = useDispatch();
  const { notif_id } = useParams();
  const history = useHistory();
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.toUpperCase();

  useEffect(() => {
    dispatch(getCustomerNotificationDetail(notif_id));
  }, [dispatch]);

  if (lang === "EN") {
    moment.locale("en");
  } else {
    moment.locale("ja");
  }

  const formatDate = {
    "EN": "MMM. Do, YYYY (ddd), HH:mm",
    "JP": "YYYY年M月D日（dd）HH:mm"
  }

  return (
    <>
      {loading ? <SkeletonLoading variant="detail" /> : (
        <div className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem] tw:mt-4">
          <div className="tw:flex-1 tw:p-4">
            <div className="tw:p-4">
              <div className="tw:flex tw:items-center tw:mb-4">
                <Link to="/my-page/notifications" style={{ textDecoration: "none" }}>
                  <p
                    className="fw-100 tw:text-left tw:text-[#212529]! noto back-to-vehicle-selection-button"
                  >
                    <div
                      className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none back-to-vehicle-selection-button"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <BackAltIcon
                        aria-label="Back icon"
                        role="img"
                        style={{ marginRight: "5px" }}
                      />
                      &nbsp; {t("myPage.notification.detail.back")}
                    </div>
                  </p>
                </Link>
              </div>

              {/* START OF HEADER SECTION */}
              <p className="noto fs-16 fw-900">
                {lang === "EN" ? notification?.titleEN : notification?.titleJP}
              </p>
              <hr className="divider-grey" />

              {/* END OF HEADER SECTION */}


              {/* START OF BODY SECTION */}
              <>{/* Boddy message */}
                <p className="tw:my-6">
                  {lang === "EN" ? notification?.descriptionEN : notification?.descriptionJP}
                </p>
              </>

              {/* Booking Info */}
              {notification?.isShowBooking && (
                <>
                  <hr className="divider-dash" />  {/* # This divider only for booking modification request */}
                  <p className="fw-14 tw:text-[#0d6efd]! fw-700">{t("myPage.notification.detail.title.requestedBookingDetail")}</p>{/* Subtitle */}
                  {/* <p className="fw-14 fw-700 tw:m-0">Date & Time:</p>
                  <p className="fw-14 tw:m-0">
                    Pick-up: <Moment format="dddd, MMMM Do, YYYY HH:mm">{notification.bookingId.travelDate}</Moment>
                  </p>
                  <p className="fw-14 tw:m-0">
                    Drop-off: <Moment format="dddd, MMMM Do, YYYY HH:mm">{notification.bookingId.bookingInfo[0].cutomerDropOffTimeWithAdditinalTime}</Moment>
                  </p> */}

                  <p className="fw-14 fw-700 tw:m-0">{t("myPage.notification.detail.title.pickupTime")}</p>
                  <p className="fw-14 tw:m-0">{moment(notification?.bookingId?.pickupDateTime).format(formatDate[lang])}</p>
                  <p className="fw-14 fw-700 tw:mt-4 tw:mb-0">{t("myPage.notification.detail.title.dropoffTime")}</p>
                  <p className="fw-14 tw:m-0">{moment(notification?.bookingId?.customerDropoffDateTime).format(formatDate[lang])}</p>
                  <p className="fw-14 fw-700 tw:mt-4 tw:mb-0">{t("myPage.notification.detail.title.pickupLocation")}</p>
                  <p className="fw-14 tw:m-0">{notification?.bookingId?.pickupLocation?.label}</p>

                  <p className="fw-14 fw-700 tw:mt-4 tw:mb-0">{t("myPage.notification.detail.title.dropoffLocation")}</p>
                  {notification?.bookingId?.destinations.map((item, index) => {
                    return (
                      <div>
                        <p className="fw-14 tw:m-0">{item.label}</p>
                        {index == notification?.bookingId?.destinations?.length - 1 ? "" : <br />}
                      </div>
                    );
                  })}

                  <p className="fw-14 fw-700 tw:mt-4 tw:mb-0">{t("myPage.notification.detail.title.message")}</p>
                  {
                    (notification?.bookingId?.message?.filter(msg => msg.note != "").length == 0) ? (
                      <p className="fw-14 tw:m-0">None</p>
                    ) : (
                      notification?.bookingId?.message?.map((val) => {
                        return (
                          <p className="fw-14 tw:m-0">{val.note}</p>
                        );
                      })
                    )
                  }
                </>
              )}
              {/* END OF BODY SECTION */}


              {/* START OF BUTTON ACTION SECTION */}
              {notification?.isUseButton && (
                <div className="tw:grid tw:mt-12">
                  {/* <Link to={notification?.buttonDetail?.link} style={{textDecoration: "none"}}> */}
                  <button
                    type="button"
                    className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none tw:bg-[#d4b055] tw:border-[#d4b055] tw:text-[#4a4a4a] tw:hover:bg-[#c2a86b] tw:hover:border-[#c2a86b] tw:hover:opacity-60 tw:py-2"
                    onClick={() => {
                      window.location.href = notification?.buttonDetail?.link
                    }}
                  >
                    <div className="tw:flex tw:items-center tw:justify-center">
                      {lang == "EN" ? notification?.buttonDetail?.textEN : notification?.buttonDetail?.textJP}
                      <i className="tw:pl-2">
                        <ArrowRightIcon color="#4A4A4A" size={24} />
                      </i>
                    </div>
                  </button>
                  {/* </Link> */}
                </div>
              )}
              {/* EMD OF BUTTON ACTION SECTION */}


            </div>
          </div>
        </div>
      )
      }
    </>
  );
};

export default NotificationDetail;
